exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-dc85c580],\n.fade-leave-active[data-v-dc85c580] {\n  transition: opacity .3s\n}\n.fade-enter[data-v-dc85c580],\n.fade-leave-to[data-v-dc85c580]\n/* .fade-leave-active in <2.1.8 */\n\n{\n  opacity: 0\n}\n.box[data-v-dc85c580] {\n  width: 200px;\n  height: 200px;\n}\n.yellow[data-v-dc85c580] {\n  background-color: yellow;\n}\n.blue[data-v-dc85c580] {\n  background-color: blue;\n}\n.h-32[data-v-dc85c580]{\n  height: 32;\n}\n.w-300[data-v-dc85c580]{\n  width: 300px;\n}\n.elipsis[data-v-dc85c580]{\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports
